import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { MCBHS080InitRequest } from 'types/MCBHS080/MCBHS080InitRequest'
import { MCBHS080NewRequest } from 'types/MCBHS080/MCBHS080NewRequest'
import { MCBHS080OverwriteRequest } from 'types/MCBHS080/MCBHS080OverwriteRequest'

const messageInitRequest: MCBHS080InitRequest = {
  sendCount: 0,
  emailFailedCount: 0,
}

// 28KH #181571 START
const initialState: {
  messageInitRequest: MCBHS080InitRequest
  messageTemplateUpperLimitFlg: boolean
} = {
  messageInitRequest: messageInitRequest,
  messageTemplateUpperLimitFlg: true
}
// 28KH #181571 END

const mcbMessageDeadlineCompSlice = createSlice({
  name: 'mcbMessageDeadlineComp',
  initialState,
  reducers: {
    getInit(state, action: PayloadAction<MCBHS080InitRequest>) {
      console.log('Reducer getInit1')
      const initRequest = action.payload
      return state
    },
    // 28KH #181571 START
    setMessageTemplateUpperLimitFlg(state, action: PayloadAction<boolean>) {
      state.messageTemplateUpperLimitFlg = action.payload
    },
    overwrite(state, action: PayloadAction<{ apiData: MCBHS080OverwriteRequest }>) {
      return state
    },
    saveNew(state, action: PayloadAction<{ apiData: MCBHS080NewRequest }>) {
      return state
    },
    // 28KH #181571 END
  },
})

// 28KH #181571 START
export const { getInit, setMessageTemplateUpperLimitFlg, overwrite, saveNew } = mcbMessageDeadlineCompSlice.actions
// 28KH #181571 END
export default mcbMessageDeadlineCompSlice.reducer
